import { render } from "./NavSide.vue?vue&type=template&id=0dee1d8e&scoped=true&ts=true"
import script from "./NavSide.vue?vue&type=script&lang=ts"
export * from "./NavSide.vue?vue&type=script&lang=ts"

import "./NavSide.vue?vue&type=style&index=0&id=0dee1d8e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dee1d8e"]])

export default __exports__